import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "lucide-react";
import ReactPlayer from "react-player";

export default function MediaCarousel({ media }) {
    const swiperRef = useRef(null);
    const thumbnailRefs = useRef([]); // Store thumbnail button refs
    const [activeIndex, setActiveIndex] = useState(0);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    useEffect(() => {
        if (thumbnailRefs.current[activeIndex]) {
            thumbnailRefs.current[activeIndex].scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center", // Ensures horizontal scrolling
            });
        }
    }, [activeIndex]); // Runs 

    return (
        <div className="w-full flex flex-col items-center">
            <div className="relative flex items-center w-full max-w-3xl">
                {/* Left Button - Hide if at the beginning */}
                {!isBeginning && (
                    <button
                        onClick={() => swiperRef.current?.slidePrev()}
                        className="absolute left-0 z-10 m-2 bg-white text-bright-green p-3 rounded-full hover:bg-bright-green hover:text-white"
                    >
                        <ChevronLeft size={36} />
                    </button>
                )}

                {/* Swiper Component */}
                <Swiper
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                        setIsBeginning(swiper.isBeginning);
                        setIsEnd(swiper.isEnd);
                    }}
                    onSlideChange={(swiper) => {
                        setActiveIndex(swiper.activeIndex);
                        setIsBeginning(swiper.isBeginning);
                        setIsEnd(swiper.isEnd);
                    }}
                    modules={[Navigation, Pagination]}
                    className="w-full"
                >
                    {media.map((item, index) => (
                        <SwiperSlide key={index} className="flex justify-center">
                            {item.type === "image" ? (
                                <img
                                    src={item.url}
                                    alt=""
                                    className="w-full h-[72vh] object-cover rounded-xl"
                                />
                            ) : (
                                <ReactPlayer
                                    url={item.url}
                                    controls
                                    width="100%"
                                    height="72vh"
                                />
                            )}
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Right Button - Hide if at the end */}
                {!isEnd && (
                    <button
                        onClick={() => swiperRef.current?.slideNext()}
                        className="absolute right-0 z-10 m-2 bg-white text-bright-green p-3 rounded-full hover:bg-bright-green hover:text-white"
                    >
                        <ChevronRight size={36} />
                    </button>
                )}
            </div>

            {/* Custom Pagination Below Image */}
            {/* <div className="mt-4 flex gap-2">
                {media.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => swiperRef.current?.slideTo(index)}
                        className={`w-4 h-4 rounded-full border-bright-green border-[2px] ${index === activeIndex ? "bg-bright-green" : "bg-white"}`}
                    />
                ))}
            </div> */}
            {/* Thumbnails */}
            <div className="mt-4 w-full max-w-3xl overflow-x-auto hide-scrollbar">
            <div className="flex gap-2 w-max">
                {media.map((item, index) => (
                    <button
                        key={index}
                        ref={(el) => (thumbnailRefs.current[index] = el)}
                        onClick={() => swiperRef.current?.slideTo(index)}
                        className={`w-20 h-16 rounded-md border-2 ${index === activeIndex ? "border-bright-green" : "border-gray-300"
                            }`}
                    >
                        {item.type === "image" ? (
                            <img
                                src={item.url}
                                alt=""
                                className="w-full h-full object-cover rounded-md"
                            />
                        ) : (
                            <ReactPlayer
                                url={item.url}
                                light={true} // Shows the video thumbnail
                                width="100%"
                                height="100%"
                            />
                        )}
                    </button>
                ))}
            </div>
            </div>

        </div>
    );
}
